import sha1 from 'tiny-sha1';
import { DateTime } from 'luxon';
import { accountStatus } from 'shared/constants.json';

const contractStartThreshold = { months: 1 };
const userActivatedAtThreshold = { months: 1 };
const userSessionsThreshold = 4;
const feedbackLastAskedThresholdByDismissals = [{ months: 3 }, { months: 3 }, { months: 6 }, { months: 12 }];
const feedbackLastAnsweredThreshold = { months: 6 };

const nullDate = DateTime.local(2020);
const toDateTime = (iso) => (iso ? DateTime.fromISO(iso) : nullDate);

const sampledPercentage = 25;

// Deterministic per identity and quarter, so reloading never re-rolls the draw.
const isSampled = (identityUid, now) => {
  const digest = sha1(new TextEncoder().encode(`${identityUid}:${now.year}-Q${now.quarter}`));
  return parseInt(digest.slice(-8), 16) % 100 < sampledPercentage;
};

const lastAskedThreshold = (consecutiveDismissals = 0) => feedbackLastAskedThresholdByDismissals[
  Math.min(consecutiveDismissals, feedbackLastAskedThresholdByDismissals.length - 1)
];

// feedbackHistory holds the identity-wide cooldown state resolved by sentinel /me
// ({ lastAskedAt, lastAnsweredAt, consecutiveDismissals, optedOut }), so the cooldown
// holds across accounts rather than being derived from the current account's feedback only.
export const canDisplayAppFeedback = (account, user, feedbackHistory, t = DateTime.local().toISO()) => {
  const now = DateTime.fromISO(t);
  if (account.accountSettings.status !== accountStatus.active) {
    return false;
  }
  if (DateTime.fromISO(account.accountSettings.expiresAt) < now) {
    return false;
  }
  if (account.customerContract.startedAt === undefined) {
    return false;
  }
  if (!account.accountSettings.receivesInAppFeedback) {
    return false;
  }
  if (DateTime.fromISO(account.customerContract.startedAt) > now.minus(contractStartThreshold)) {
    return false;
  }
  if (DateTime.fromISO(user.activatedAt) > now.minus(userActivatedAtThreshold)) {
    return false;
  }
  if (user.identity.sessionCount < userSessionsThreshold) {
    return false;
  }

  if (feedbackHistory?.optedOut) {
    return false;
  }

  const lastAskedTimestamp = toDateTime(feedbackHistory?.lastAskedAt);
  const lastAnsweredTimestamp = toDateTime(feedbackHistory?.lastAnsweredAt);

  if (lastAskedTimestamp > now.minus(lastAskedThreshold(feedbackHistory?.consecutiveDismissals))) {
    return false;
  }
  if (lastAnsweredTimestamp > now.minus(feedbackLastAnsweredThreshold)) {
    return false;
  }
  return isSampled(user.identity.uid, now);
};
